export const sanitizePhoneString = (value?: string | null) => {
  if (!value) return '';

  return value.replace(/[^a-zA-Z0-9\s]/g, "");
};

